<template>
    <div v-show="activeIndex == index">
        <div class="search-top">
            <span>BU名称</span>
            <el-select class="top-choose" v-model="bu_id" @change="changeBu">
                <z-limitOption v-for="item in bu_list" :key="item.id" :value="item.id" :label="item.bu_name">
                </z-limitOption>
            </el-select>
            <span>时间</span>
            <el-date-picker class="top-choose" v-model="search.start_date" type="date" placeholder="选择日期" :picker-options="picker_special">
            </el-date-picker>
            <small>~</small>
            <el-date-picker class="top-choose" v-model="search.end_date" type="date" placeholder="选择日期" :picker-options="picker_special">
            </el-date-picker>
            <div class="back-btn blue shift" @click="searchClick()">时间查询</div>
        </div>

        <div class="back-list search">
            <div class="list-head">
                <!-- <div>快币名称</div> -->
                <div>日期</div>
                <div>奖金变化({{ task_curr.currency_name }})</div>
                <div>奖金余额({{ task_curr.currency_name }})</div>
                <div>备注</div>
            </div>
            <z-scrollDiv class='main'>
                <div class="list-item" v-for="item in dataList" :key="item.id">
                    <!-- <div>{{ item.currency_name }}</div> -->
                    <div>{{ item.bill_time | justDate }}</div>
                    <div :class="{add:item.bill_type == 1,reduce:item.bill_type!=1}">{{ (item.bill_type==1?"+":"-")+item.trans_amount }}</div>
                    <div>{{ item.balance }}</div>
                    <div class="overhide" :title="item.remark">{{ item.remark }}</div>
                </div>
                <z-noData :list="dataList"></z-noData>
            </z-scrollDiv>
        </div>

        <el-pagination
            @current-change="searchClick"
            :current-page.sync="data.current_page"
            :total="data.total"
            :page-size="data.per_page"
            layout="prev, pager, next, jumper"
        ></el-pagination>
    </div>
</template>

<script>
    import { mapState,mapGetters } from 'vuex';

    export default {
        props:['index','activeIndex'],
        data(){
            return {
                bu_id:"",
                search:{
                    start_date:"",
                    end_date:"",
                },
                data:{},
            }
        },
        computed:{
            ...mapState(["picker_special",'bu_list']),
            ...mapGetters(['task_curr']),
            dataList(){
                return this.data.list;
            }
        },

        created(){
            if(this.activeIndex == this.index){
                this.fresh();
            }
        },

        watch:{
            activeIndex(val){
                if(val == this.index){
                    this.fresh();
                }
            }
        },

        methods:{
            changeBu(id){
                this.search.start_date = '';
                this.search.end_date = '';
                this.searchClick();
            },
            fresh(){
                if(this.bu_id == ''){
                    this.$func.getBuList(true,list=>{
                        this.bu_id = list[0] && list[0].id;
                    });
                }else{
                    this.searchClick(this.data.current_page);
                }
            },
            searchClick(page){  //查询
                let obj = {
                    page:page,
                    start_date:this.search.start_date,
                    end_date:this.search.end_date,
                };
                this.getData(obj);
            },
            getData(obj = {}){
                let url = `api/admin/bonus/recharge/records`;
                obj.bu_id = this.bu_id,
                this.$http.get(url,{params:obj}).then(res=>{
                    if(res.status == 200){
                        this.data = res.res_data;
                    }
                });      
            },

        },

    }
</script>

<style lang="less" scoped>
    // 增减的数字颜色
    .add{
        color:#34b96c;
        // color:#43a2ff;
    }
    .reduce{
        color:#ff8383;
    }
    
    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 15%;
        }
        >div:nth-of-type(2){
            width: 15%;
        }
        >div:nth-of-type(3){
            width: 15%;
        }
        >div:last-of-type{
            width: 30%;
        }
    }
</style>





// WEBPACK FOOTER //
// bonus-note.vue?0853509d